import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/h1K7wchd8DrbaDPHhF3buh/ChatGPT-Image-22-jun-2026_-22_30_15.webp';
export function FinalCTA() {
  return <section className="py-14 px-4 sm:px-6 bg-brand-navy text-white text-center relative overflow-hidden" data-id="element-44">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-45" />

      <div className="relative z-10" data-id="element-46">
        <p className="text-xs font-black text-brand-orange uppercase tracking-widest mb-4" data-id="element-47">
          ONE LAST CHANCE
        </p>

        <p className="text-sm sm:text-base font-medium mb-8 leading-relaxed max-w-2xl mx-auto text-white/90" data-id="element-48">
          Your athletes deserve more than improvised workouts. Stop spending
          hours creating sessions every week. Stop second-guessing your
          programming decisions. Stop wondering if your athletes are progressing
          as fast as they could.
          <span className="font-bold text-white block mt-4" data-id="element-49">
            Give every runner a structured, professional, and results-driven
            training experience. Give yourself the coaching system you should
            have had from Day One.
          </span>
        </p>

        <div className="bg-white/10 border border-brand-teal/40 rounded-xl p-5 mb-8 shadow-lg max-w-sm mx-auto backdrop-blur-sm" data-id="element-50">
          <p className="text-xs sm:text-sm font-bold text-brand-teal mb-2 uppercase tracking-wide" data-id="element-51">
            🏃 RUNNING COACH READY™
            <br data-id="element-52" />
            6-in-1 Complete Box Set + 5 Premium Bonuses
          </p>
          <p className="text-base line-through text-white/50 mb-1" data-id="element-53">$97 USD</p>
          <p className="text-4xl font-heading font-black text-white leading-none" data-id="element-54">
            Only: $27 USD
          </p>
        </div>

        <a href="#pricing" className="block cursor-pointer mb-8" data-id="element-55">
          <img src={PRODUCT_IMG} alt="Running Coach Ready Box Set" className="w-full max-w-[280px] mx-auto object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-56" />
        </a>

        <div className="mb-6 max-w-md mx-auto" data-id="element-57">
          <CTAButton data-id="element-58">🚀 YES, I WANT MY RUNNING COACH READY™ PACK</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-5 text-[10px] sm:text-xs font-bold text-white/80" data-id="element-59">
          <div className="flex items-center gap-1.5" data-id="element-60">
            <Zap className="w-4 h-4 text-brand-orange" data-id="element-61" />
            <span data-id="element-62">Immediate Access — Delivered By Email</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-63">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-64" />
            <span data-id="element-65">4.9/5 — Verified Professional Reviews</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-66">
            <Shield className="w-4 h-4 text-brand-green" data-id="element-67" />
            <span data-id="element-68">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}